import { createContext, Dispatch, ReactNode, SetStateAction } from 'react';

type ContextType = {
  baseUrl: string;
  jwt?: string;
  setJwt?: Dispatch<SetStateAction<string | undefined>>;
  setBaseUrl?: Dispatch<SetStateAction<string>>;
};

export const ServiceConfigContext = createContext<ContextType>({ baseUrl: '' });

export const ServiceProvider = ({ children, baseUrl, jwt }: { children: ReactNode; baseUrl: string; jwt?: string }) => {
  // Pass the props straight into the context so a new `jwt` reaches consumers in the SAME render it
  // changes. Previously the props were mirrored into `useState` and updated inside
  // `useEffect(() => setJwt(inputJwt), [inputJwt])`, so the service's token trailed the auth state by
  // one render: right after an in-place login `isAuthenticated` was already true while the service
  // still carried no token, so the first authenticated request fired on the anonymous axios instance
  // and got a 401, then an identical request succeeded once the mirror caught up. The `setJwt` /
  // `setBaseUrl` setters were never placed on the context value, so nothing consumed them.
  return <ServiceConfigContext.Provider value={{ baseUrl, jwt }}>{children}</ServiceConfigContext.Provider>;
};
